import { createStyles, makeStyles, Theme } from "@material-ui/core";

export default makeStyles((theme: Theme) =>
  createStyles({
    toolbar: {
      display: "flex",
      flexDirection: "row-reverse",
      alignItems: "center"
    },
    switchContainer: {
      height: "40px",
      padding: "5px 0 0 10px"
    },
    switchContainerAbsolute: {
      position: "absolute",
      width: "500px",
      padding: "10px 0 0 10px",
      zIndex: 100,
      [theme.breakpoints.down("md")]: {
        display: "none"
      }
    },
    switch: {
      margin: "0px 4px 0px 4px"
    },
    dateRangeContainer: {
      position: "absolute",
      padding: "5px",
      zIndex: 100,
      left: "10px",
      fontSize: "0.9rem !important",
      "& .react-daterange-picker": {
        marginBottom: "0 !important",
        marginLeft: "10px",
        fontSize: "0.9rem"
      }
    },
    disabledInfo: {
      marginLeft: "20px"
    }
  })
);
